/* ============================================================
   custom.footer.js — Filthy Farmgirl footer
   29 Jul 2026; breakpoint moved to 990 in the 30 Jul layout rewrite

   The footer is deliberately almost script-free. This file does two jobs.

   1. The six link groups are rendered as <details open> so that with
      JavaScript off the whole sitemap is visible — the safe failure for a
      footer whose entire purpose is that every page is reachable from every
      page. Below 990px the footer is its compact accordion layout, so the
      groups should start collapsed there. `open` is an attribute, not
      something CSS can override. Hence this.

      990 is THE footer breakpoint — the same line where stock Horizon swaps
      its scroll container (base.css) — and it appears in exactly two places:
      here and custom.footer.css. If it ever moves, move both.

   2. Back to top, which respects prefers-reduced-motion.
   ============================================================ */
(function () {
  'use strict';

  var footer = document.querySelector('.ffg-footer');
  if (!footer) return;

  /* ---- 1. accordions ---------------------------------------------------- */
  var groups = footer.querySelectorAll('.ffg-col details');
  var desktop = window.matchMedia('(min-width: 990px)');

  function sync(isDesktop) {
    for (var i = 0; i < groups.length; i++) {
      if (isDesktop) {
        // Desktop columns are ALWAYS open — sync unconditionally, including
        // groups the shopper collapsed while the window was narrow.
        groups[i].setAttribute('open', '');
      } else if (groups[i].dataset.ffgTouched !== 'true') {
        // Compact: collapse, but never a group the shopper opened themselves.
        groups[i].removeAttribute('open');
      }
    }
  }

  for (var j = 0; j < groups.length; j++) {
    // CLICK, not `toggle`: toggle also fires for programmatic open/close, so
    // sync()'s own collapse used to mark every group as shopper-touched on any
    // narrow load — after which sync skipped them all and the desktop columns
    // stayed shut unless clicked one by one.
    groups[j].querySelector('summary').addEventListener('click', function (e) {
      if (desktop.matches) {
        // Desktop columns are plain lists, not accordions. A summary click
        // would collapse one; swallow it.
        e.preventDefault();
      } else {
        this.parentNode.dataset.ffgTouched = 'true';
      }
    });
  }

  sync(desktop.matches);
  // addEventListener on MediaQueryList is unsupported in older Safari, which
  // is worth caring about on a store whose traffic is 39% mobile.
  if (desktop.addEventListener) {
    desktop.addEventListener('change', function (e) { sync(e.matches); });
  } else if (desktop.addListener) {
    desktop.addListener(function (e) { sync(e.matches); });
  }

  /* ---- 2. back to top --------------------------------------------------- */
  var top = footer.querySelector('[data-ffg-top]');
  if (top) {
    top.addEventListener('click', function () {
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      // At >=990 Horizon's scroller is .page-wrapper, not the document
      // (base.css squeeze layout) — window.scrollTo is a silent no-op there.
      var scroller = desktop.matches
        ? document.querySelector('.page-wrapper') || window
        : window;
      scroller.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' });
    });
  }
})();
